<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/student-course-equalizations', text: 'studentCourseEqualization_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'studentCourseEqualization_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker()" *ngIf="!studentPickerOpened && (canPickStudent || student)">
                <i class="fi fi-rs-user"></i>
                {{'studentCourseEqualization_btnPickStudent' | translate}}
            </button>

            <button type="button" class="btn btn-outline-primary" *ngIf="canEdit && !studentPickerOpened" [routerLink]="['/student-course-equalizations/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="setStudent($event)"></app-person-picker>

    <ng-container *ngIf="!studentPickerOpened">
        <div class="data-value" *ngIf="canPickStudent && student">
            <label>{{'studentCourseEqualization_lblStudent' | translate}}</label>
            <div>{{student.FirstName}} {{student.LastName}}, {{student.Email}}</div>
        </div>

        <app-table [rows]="items" [columns]="columns" *ngIf="!canPickStudent || student">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td class="hidden-sm-down">
                        <app-student-course-equalization-status [value]="getStatus(row)"></app-student-course-equalization-status>
                    </td>
                    <td class="hidden-md-up">
                        <div>
                            <app-student-course-equalization-status [value]="getStatus(row)"></app-student-course-equalization-status>
                        </div>
                        <div>{{row.Speciality}} ({{row.StudyYear}})</div>
                        <div class="text-sub">
                            {{row.Created | appDate}}
                            <ng-container *ngIf="row.Registered"> / {{row.Registered | appDate}}</ng-container>
                        </div>
                    </td>
                    <td class="hidden-sm-down hidden-lg-up">
                        <div>{{row.Speciality}} ({{row.StudyYear}})</div>
                        <div class="text-sub">
                            {{row.Created | appDate}}
                            <ng-container *ngIf="row.Registered"> / {{row.Registered | appDate}}</ng-container>
                        </div>
                    </td>
                    <td class="hidden-md-down">{{row.Speciality}}</td>
                    <td class="hidden-md-down">{{row.StudyYear}}</td>
                    <td class="hidden-md-down">
                        {{row.Created | appDate}}
                        <ng-container *ngIf="row.Registered"> / {{row.Registered | appDate}}</ng-container>
                    </td>
                    <td>
                        <div class="table-actions">
                            <button type="button" (click)="delete(row)" *ngIf="canDelete(row)" class="btn btn-outline-primary btn-icon"
                                    [ngbTooltip]="'delete' | translate">
                                <i class="fi fi-rs-trash"></i>
                            </button>

                            <a class="btn btn-outline btn-icon" href="{{getDvsProtocolUrl(row)}}"
                                    [ngbTooltip]="'studentCourseEqualization_btnDownloadDvsDocument' | translate" *ngIf="row.Registered">
                                <i class="fi fi-rs-document"></i>
                            </a>

                            <button type="button" class="btn btn-outline btn-icon" [routerLink]="['/student-course-equalizations', row.Id] | localize"
                                    [ngbTooltip]="'open' | translate">
                                <i class="fi fi-rs-pencil"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </ng-container>

    <section class="block" *ngIf="canPickStudent">
        <header class="block-header">
            <h5>{{'studentCourseEqualization_assigned' | translate}}</h5>
        </header>

        <app-table [rows]="assignedItems" [columns]="assignedColumns">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td class="hidden-md-down">
                        {{row.Name}} {{row.Surname}}
                        <div class="text-sub">{{row.Email}}</div>
                    </td>
                    <td class="hidden-md-down">{{row.Speciality}}</td>
                    <td class="hidden-md-down">{{row.StudyYear}}</td>
                    <td class="hidden-md-down">
                        {{row.Created | appDate}}
                        <ng-container *ngIf="row.Registered"> / {{row.Registered | appDate}}</ng-container>
                    </td>
                    <td>
                        <app-student-course-equalization-status [value]="getStatus(row)"></app-student-course-equalization-status>
                        <div class="text-sub" *ngIf="row.Registered">{{row.Registered | appDate}}</div>
                    </td>
                    <td class="hidden-sm-down">
                        <div class="table-actions">
                            <a class="btn btn-outline btn-icon" href="{{getDvsProtocolUrl(row)}}"
                               [ngbTooltip]="'studentCourseEqualization_btnDownloadDvsDocument' | translate" *ngIf="row.Registered">
                                <i class="fi fi-rs-document"></i>
                            </a>

                            <button type="button" class="btn btn-outline btn-icon" [routerLink]="['/student-course-equalizations', row.Id] | localize"
                                    [ngbTooltip]="'open' | translate">
                                <i class="fi fi-rs-pencil"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </section>
</div>
